/*
 * Module for handling of ajax navigation links
 */
rs.module("content/participant/benefit/directdeposit/edit",

    ["common/select-helper"],

    function (selectHelper) {

        // initialize the module
        function initialize(jsSelectors, codeValues, cssClasses, backendUrl, values) {
            var form = $.js(jsSelectors.form);
            var directDepositCountryHelper = selectHelper.getHelper(form.js(jsSelectors.directDepositCountryList));
            var bankSelectList = form.js(jsSelectors.directDepositBankSelectList);
            var directDepositBankSelectorHelper = selectHelper.getHelper(bankSelectList);

            //set values and visibility on load
            directDepositBankSelectorHelper.setValue(values.finInstitutionKey);
            form.js(jsSelectors.directDepositCountrySection).toggleClass(cssClasses.visible, values.isInternational);
            form.js(jsSelectors.directDepositAddBankCheckbox).prop('disabled', values.isInternational || values.directDepositHistoryExists);
            form.js(jsSelectors.directDepositAddBankControls).toggleClass(cssClasses.visible, values.addBankFlag);

            // enable/disable percent and amount controls when account mode changes
            form.js(jsSelectors.directDepositAccountMode).change(setPercentAmountDisable);

            // show the country selector if international deposit is checked
            // and update the bank selectlist
            form.js(jsSelectors.directDepositInternationalCheckbox).change(function () {
                directDepositCountryHelper.setValue("");
                form.js(jsSelectors.directDepositCountrySection).toggleClass(cssClasses.visible, this.checked);
                directDepositBankSelectorHelper.loadOptionsFrom(backendUrl, { isInternational: this.checked }, { withBlank: true });

                form.js(jsSelectors.directDepositAddBankCheckbox).prop('disabled', this.checked);
            });

            // show the controls to add a bank if add bank is checked
            // and disable the selectlist
            form.js(jsSelectors.directDepositAddBankCheckbox).change(function () {
                form.js(jsSelectors.directDepositAddBankControls).toggleClass(cssClasses.visible, this.checked);
                directDepositBankSelectorHelper.setValue("");
                directDepositBankSelectorHelper.setDisabled(this.checked);
                bankSelectList.clearErrors();

                form.js(jsSelectors.directDepositInternationalCheckbox).prop('disabled', this.checked);
            })

            // disable the percent and amount controls if mode is primary
            function setPercentAmountDisable() {
                var isPrimary = form.js(jsSelectors.directDepositAccountMode).val() == codeValues.primaryCode;
                if (isPrimary) {
                    //move this into a method and call on load if primary? 
                    form.js(jsSelectors.directDepositPercentControl).val(null).clearErrors();
                    form.js(jsSelectors.directDepositAmountControl).val(null).clearErrors();
                }
                else {
                    form.js(jsSelectors.directDepositPercentControl).val(null).clearErrors();
                }

                form.js(jsSelectors.directDepositPercentControl).prop('disabled', isPrimary);
                form.js(jsSelectors.directDepositAmountControl).prop('disabled', isPrimary);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);